export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="15" fill="#1F5132" />
    <g stroke="#FFFFFF" strokeWidth="4.5" strokeLinecap="round" fill="none">
      <circle cx="23" cy="22" r="6" />
      <circle cx="23" cy="42" r="6" />
      <path d="M28 26 L46 44" />
      <path d="M28 38 L46 20" />
    </g>
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="salonup-logo">
    <LogoMark />
    <span
      className={`font-logo font-semibold tracking-tight text-[1.35rem] leading-none ${
        dark ? "text-white" : "text-charcoal"
      }`}
    >
      Salon<span className={dark ? "text-salon-light" : "text-salon"}>Up</span>
    </span>
  </span>
);
